import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { ContractLotRoutingModule } from "./contract-lot-routing.module";
import { MaterialModule } from "src/app/core/material";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "src/app/shared/shared.module";
import { TranslateModule } from "@ngx-translate/core";
import { MatAutocompleteModule, MatInputModule, MatProgressBarModule } from "@angular/material";
import { NgMatAutocompleteModule } from "src/app/shared/components/autocomplete/autocomplete.module";
import { NgxMaskModule } from "ngx-mask";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { NgZorroAntdModule } from "ng-zorro-antd";
import { SlickCarouselModule } from "ngx-slick-carousel";
import { NotifyModule } from "../notify/notify.module";
import { HotTableModule } from "@handsontable/angular";
import { AddLotComponent } from "./add-lot/add-lot.component";
import { SignatureConfigLotComponent } from './signature-config-lot/signature-config-lot.component';
import { ConfigSigningFlowComponent } from './config-signing-flow/config-signing-flow.component';
import { WarningDialogComponent } from './warning-dialog/warning-dialog.component';

@NgModule({
  declarations: [
    AddLotComponent,
    SignatureConfigLotComponent,
    ConfigSigningFlowComponent,
    WarningDialogComponent
  ],
  imports: [
    CommonModule,
    ContractLotRoutingModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule,
    MatAutocompleteModule,
    MatProgressBarModule,
    NgMatAutocompleteModule,
    MatInputModule,
    NgxMaskModule.forChild(),
    NgxExtendedPdfViewerModule,
    NgZorroAntdModule,
    SlickCarouselModule,
    NotifyModule,
    HotTableModule,
  ],
  exports: [],
  entryComponents: [
    WarningDialogComponent,
    AddLotComponent,
  ],
})
export class ContractLotModule {}
